import React from 'react';
import ShortInfoCard from "../ShortInfoCard";
import { shortFunction, shortFunctionMenu, sip } from "../../translate";
import { useNavigate } from 'react-router-dom';

const { REACT_APP_SERVER } = process.env;
const color = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : '#7ebc0a';

function SipOperators({
    operatorLabel,
    operatorCountLabel,
    operatorCounts,
}) {
    const navigate = useNavigate()
    return (
        <>
            <h3 style={{ margin: '20px 20px' }}>{shortFunctionMenu.sip[+localStorage.getItem('atsLang') || 1]}</h3>
            <div className="short-cards">
                    <ShortInfoCard
                    label={`${operatorLabel} ${operatorCountLabel}`}
                    description={shortFunction.operator_description[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => navigate('/short_function/send_mail_employee')}
                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                >
                    <span
                        className="short-card__actions-item"
                        style={{
                            padding: '2px 12px',
                            color: 'white',
                            background: +operatorCounts?.sendMail > 0 ? color : '#ce405f'
                        }}
                    >
                        {+operatorCounts?.sendMail > 0 ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                    </span>
                </ShortInfoCard>

                <ShortInfoCard
                    label={`${shortFunction.speech[+localStorage.getItem('atsLang') || 1]} (${+operatorCounts?.isSpeech})`}
                    description={shortFunction.speech_desc[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => navigate('/short_function/speech')}
                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                >
                    <span
                        className="short-card__actions-item"
                        style={{
                            padding: '2px 12px',
                            color: 'white',
                            background: +operatorCounts?.isSpeech > 0 ? color : '#ce405f'
                        }}
                    >
                        {+operatorCounts?.isSpeech > 0 ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                    </span>
                </ShortInfoCard>
                <ShortInfoCard
                    label={`${shortFunction.rate[+localStorage.getItem('atsLang') || 1]} (${+operatorCounts?.rate})`}
                    description={shortFunction.rate_desc[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => navigate('/short_function/rate')}
                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                >
                    <span
                        className="short-card__actions-item"
                        style={{
                            padding: '2px 12px',
                            color: 'white',
                            background: +operatorCounts?.rate > 0 ? color : '#ce405f'
                        }}
                    >
                        {+operatorCounts?.rate > 0 ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                    </span>
                </ShortInfoCard>
                <ShortInfoCard
                    label={shortFunction.employee_permissions?.[+localStorage.getItem('atsLang') || 1] || 'Employee Permissions'}
                    description={shortFunction.employee_permissions_desc?.[+localStorage.getItem('atsLang') || 1] || 'Manage permissions for employees'}
                    onEdit={() => navigate('/short_function/employees/permissions')}
                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                >
                    <span/>
                </ShortInfoCard>
                <ShortInfoCard
                    label={shortFunction.spy?.[+localStorage.getItem('atsLang') || 1] || 'Spy server system'}
                    description={shortFunction.spy_short_desc?.[+localStorage.getItem('atsLang') || 1] || 'Configure spy admins and assign operators to listen to calls.'}
                    onEdit={() => navigate('/short_function/spy')}
                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                >
                    <span/>
                </ShortInfoCard>
            </div>
        </>
    );
}

export default SipOperators;

